import React from "react"
import { styled } from "themes"
import ReactMarkdown, { ReactMarkdownProps } from "react-markdown"

export const StyledMarkdown = styled((props: ReactMarkdownProps) => (
  <ReactMarkdown {...props} />
))``
